import * as kind from './kind';

export const collect = <T>(array: T[], key: (item: T, i: number) => any): Record<any, T> => {
  return array.reduce<Record<any, T>>((m, o, i) => {
    const name = key(o, i);
    if (kind.isNothing(name)) return m;

    return Object.assign(m, { [name]: o });
  }, {});
}

export const exclude= <T>(array: T[], item: T): T[] => {
  const index = array.indexOf(item);
  if (index >= 0) array.splice(index, 1);

  return array;
};

export const include = <T>(array: T[], item: T): T[] => {
  if (!array.includes(item)) array.push(item);

  return array;
};

export const insert = <T>(array: T[], index?: number, ...items: T[]): void => {
  array.splice(index ?? array.length, 0, ...items);
};

export const move = <T>(array: T[], from: number, to: number): void => {
  array.splice(to, 0, ...array.splice(from, 1));
};

export const remove = <T>(array: T[], item: T): boolean => {
  const index = array.indexOf(item);
  if (index >= 0) return (array.splice(index, 1).length > 0);

  return false;
};

export const wrap = <T>(value?: T | T[]): T[] => (Array.isArray(value) ? value : (!kind.isNothing(value) ? [value] : []));
